export default {
    ns: [
        "US.COLLECTION.ECONOMY", "US.COLLECTION.VALIDATIONS", "US.COMMON"
    ]
}